export default [
  {
    path: "/event/create",
    name: "EventCreate",
    component: () => import(/* webpackChunkName: "event" */ "@/views/event/eventForm.vue"),
  },
  {
    path: "/event/edit/:id",
    name: "EventEdit",
    component: () => import(/* webpackChunkName: "event" */ "@/views/event/eventForm.vue"),
  },
  {
    path: "/event/:id",
    name: "EventView",
    meta: { hideLogo: true, hideAppBar: false, hideBottomNavigation: true, navbarTitle: "Events" },
    component: () => import(/* webpackChunkName: "event" */ "@/views/event/eventView.vue"),
  },
  {
    path: "/event",
    name: "EventHome",
    component: () => import(/* webpackChunkName: "event" */ "@/views/event/eventHome.vue"),
  },
]
